import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  SiteContextActions,
  SiteContextSelectors,
  StateWithSiteContext,
} from "@spartacus/core";
import {
  combineLatest,
  filter,
  finalize,
  map,
  Observable,
  shareReplay,
  switchMap,
  take,
} from "rxjs";
import { CartActions } from "@spartacus/cart/base/core";

@Injectable({ providedIn: "root" })
export class UIGMultiSiteService {
  private inFlight$?: Observable<void>;

  constructor(
    private store: Store<StateWithSiteContext>
  ) {}

  switchSite(
    targetBaseSite: string,
    targetLanguage: string,
  ): Observable<void> {
    if (!this.inFlight$) {
      this.inFlight$ = this.runSwitch(
        targetBaseSite,
        targetLanguage,
      ).pipe(
        take(1),
        shareReplay(1),
        finalize(() => {
          this.inFlight$ = undefined;
        })
      );
    }

    return this.inFlight$;
  }

  private runSwitch(
    baseSiteId: string,
    language: string,
  ): Observable<void> {
    this.store.dispatch(new CartActions.ClearCartState());
    this.store.dispatch(new SiteContextActions.SetActiveBaseSite(baseSiteId));
    this.store.dispatch(new SiteContextActions.SetActiveLanguage(language));

    return combineLatest([
      this.store.select(SiteContextSelectors.getActiveBaseSite),
      this.store.select(SiteContextSelectors.getActiveLanguage),
    ]).pipe(
      filter(
        ([activeBaseSite, activeLanguage]) =>
          activeBaseSite === baseSiteId && activeLanguage === language
      ),
      take(1),
      map((): void => undefined)
    );
  }

 
}
